import * as React from 'react'

import { HeroRedesign } from 'sdk/sections/hero-redesign/HeroRedesign'

import type { ResourcesHeroCmsContent } from 'core/services/cms/interfaces'

import resourcesHeroBgLarge from '../../assets/resources-hero-bg-large.jpg'
import resourcesHeroBgSmall from '../../assets/resources-hero-bg-small.jpg'
import resourcesHeroBgXsm from '../../assets/resources-hero-bg-xsm.jpg'

interface HeroProps {
  className?: string
  content: ResourcesHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ className, content }) => {
  return (
    <HeroRedesign
      imageDesktop={resourcesHeroBgLarge}
      imageTablet={resourcesHeroBgSmall}
      imageMobile={resourcesHeroBgXsm}
      titleText={content.titleText}
      description={content.description}
      className={className}
    />
  )
}
